<!-- src/components/new-tip-v2/VisitPhotosGallery.vue -->
<!--
  Galerie des photos d'une visite v2.

  Identique à celle de la v1 à une chose près : les libellés viennent de
  constants/newTipV2, où le planogramme et la PLV sont deux types distincts
  (la v1 avait un type combiné « planogram_plv »). Réutiliser le composant v1
  afficherait les clés brutes pour ces deux types.
-->
<template>
  <div>
    <div v-for="(typeInfo, typeKey) in groupedPhotos" :key="typeKey" class="mb-4">
      <div class="text-subtitle-2 mb-2">
        {{ typeInfo.label }}
        <span class="text-caption grey--text">({{ typeInfo.photos.length }})</span>
      </div>
      <v-row dense>
        <v-col v-for="photo in typeInfo.photos" :key="photo.id" cols="6" sm="4" md="3">
          <v-card outlined class="photo-card" @click="openLightbox(photo)">
            <v-img :src="photo.url" :aspect-ratio="1" class="grey lighten-3">
              <template #placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate size="24" color="grey lighten-2" />
                </v-row>
              </template>
            </v-img>
            <v-card-text class="py-1 px-2 text-caption grey--text">
              {{ formatDateTime(photo.taken_at) }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <p v-if="flatPhotos.length === 0" class="text-body-2 grey--text mb-0">
      Aucune photo pour cette visite.
    </p>

    <vue-easy-lightbox
      :visible="lightboxVisible"
      :imgs="lightboxImages"
      :index="lightboxIndex"
      @hide="lightboxVisible = false"
    />
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';
import { PHOTO_TYPES } from '@/constants/newTipV2';
import { formatDateTime } from '@/helpers/formatters';

export default {
  name: 'NewTipV2VisitPhotosGallery',
  components: { VueEasyLightbox },
  props: {
    photos: { type: [Object, Array], default: () => ({}) },
  },
  data() {
    return { lightboxVisible: false, lightboxIndex: 0 };
  },
  computed: {
    flatPhotos() {
      // Accepte soit { type: [photos] } soit [photos]
      if (Array.isArray(this.photos)) return this.photos;
      if (!this.photos) return [];
      return Object.values(this.photos).flat();
    },
    groupedPhotos() {
      const source = Array.isArray(this.photos)
        ? this.groupByType(this.photos)
        : (this.photos || {});

      const grouped = {};
      Object.entries(source).forEach(([type, photos]) => {
        grouped[type] = {
          label: (PHOTO_TYPES[type] && PHOTO_TYPES[type].label) || type,
          photos: photos || [],
        };
      });
      return grouped;
    },
    lightboxImages() {
      return this.flatPhotos.map(p => ({ src: p.url, title: p.taken_at }));
    },
  },
  methods: {
    formatDateTime,
    groupByType(arr) {
      return arr.reduce((acc, p) => {
        (acc[p.type] = acc[p.type] || []).push(p);
        return acc;
      }, {});
    },
    openLightbox(photo) {
      this.lightboxIndex = this.flatPhotos.findIndex(p => p.id === photo.id);
      this.lightboxVisible = true;
    },
  },
};
</script>

<style scoped>
.photo-card { cursor: pointer; transition: transform 0.15s; }
.photo-card:hover { transform: scale(1.02); }
</style>
